<template>
    <Link :href="item.postUrl" class="group flex items-center px-2 py-3 space-x-3">
        <div class="flex-initial">
            <avatar :user="item.user" class="w-8 h-8" />
        </div>
        <div class="flex flex-1 items-center justify-between align-middle text-sm">
            <div class="grow text-gray-600 dark:text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-indigo-200">
                <component :is="item.type + 'Activity'" :item="item" />
            </div>
            <div class="shrink-0 text-right text-gray-500 dark:text-gray-400">
                {{ item.createdAt | when }}
            </div>
        </div>
    </Link>
</template>

<script>
import PledgeActivity from "./PledgeActivity"
import CommentLikeActivity from "./CommentLikeActivity"
import PostLikeActivity from "./PostLikeActivity"

export default {
    components: {
        PledgeActivity,
        CommentLikeActivity,
        PostLikeActivity,
    },

    props: {
        item: {
            required: true,
            type: Object,
        },
    },
}
</script>
